import React from 'react'

import { Icon } from 'shpmtcd'
import './style/continueShopping.scss'

const ContinueShopping = () => (
  <div className='continue-shopping-wrapper'>
    <a href={`${window.location.origin}/`} className='continueShopping'>
      <Icon type='shpmtcdicon-arrow-left-thin' />
      <p> Continue Shopping </p>
    </a>
  </div>
)

export default ContinueShopping
